class THWeeklyPrice extends HTMLElement {
  connectedCallback() {
    this.refresh = () => {
      const active = Date.now() < Date.parse(this.dataset.ends);
      this.querySelector('[data-th-offer]').hidden = !active;
      this.querySelector('[data-th-regular]').hidden = active;
      if (!active) clearInterval(this.timer);
    };
    this.refresh();
    if (Date.now() < Date.parse(this.dataset.ends)) this.timer = setInterval(this.refresh, 1000);
    document.addEventListener('visibilitychange', this.refresh);
  }
  disconnectedCallback() {
    clearInterval(this.timer);
    document.removeEventListener('visibilitychange', this.refresh);
  }
}
if (!customElements.get('th-weekly-price')) customElements.define('th-weekly-price', THWeeklyPrice);
